import styled from 'styled-components';
import { Alert } from 'elmo-elements';

export const StyledAlert = styled(Alert)`
    margin-bottom: 30px;
`;
